import { render, staticRenderFns } from "./backVendorTable.vue?vue&type=template&id=29333a3e&"
import script from "./backVendorTable.vue?vue&type=script&lang=js&"
export * from "./backVendorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports